<template>
<div>
    <div class="d-flex">
        <div class="col-md-3">
            <Painelocorrence :statusOcorencia="statusOcorencia" :teste="a" :refreshResumo="refreshSubmit" :dataDetails="dataDetails"></Painelocorrence>
        </div>
        <div class="col-md-9">
             <DetailsOcurrence @teste="teste"  :statusOcorencia="statusOcorencia"  @refreshResumo="refreshResumo" :refreshLog="refreshLog" :dataDetails="dataDetails"></DetailsOcurrence>
        </div>
    </div>
        <div id="info-flat-button" v-if="(lflatbutton)">
            <button class="button-app " v-if="dataDetails.statusOcorencia < 3 && dataDetails.statusOcorencia != -1" @click="aprovar"><i class="fas fa-thumbs-up mr-1"></i>APROVAR</button>
            <button class="button-undo mt-2"  v-if="dataDetails.statusOcorencia != 1" @click="returnstatus"><i class="fas fa fa-undo mr-1"></i> VOLTAR STATUS</button>
            <button class="button-rep mt-2" v-if="dataDetails.statusOcorencia < 3 && dataDetails.statusOcorencia != -1" @click="reprovar"><i class="fas fa-thumbs-down mr-1"></i> CANCELAR</button>
            <!-- Unir SAP aqui é escolha manual (só 16 empreendimentos no SAP, sem validação contra a
                 obra/empreendimento do chamado) — por isso restrito a ADM QMA. -->
            <button v-if="hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL)" class="button-unir mt-2" :class="dataDetails.temVinculoSap ? 'button-unir-feito' : 'button-unir-pendente'" @click="abrirUnir"><i class="fas fa-link mr-1"></i> UNIR SAP</button>
        </div>
        <button id="add-new-ocurrence" @click="flatbuttonon" v-if="!hasRole(roles.RW_REAL_ESTA_USER_OBRA)"
              >+
        </button>

        <b-modal ref="modalUnirSap" title="Unir chamado com casa do SAP" hide-footer size="lg">
          <b-form-group label="Empreendimento (SAP)">
            <b-form-select v-model="unir.codEmp" :options="unir.empreendimentos" @change="onChangeEmpreendimento">
              <template slot="first"><option :value="null">Selecione...</option></template>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Unidade / Casa (SAP)" v-if="unir.codEmp !== null">
            <b-form-select v-model="unir.casaIdx" :options="unir.unidadesOptions">
              <template slot="first"><option :value="null">Selecione...</option></template>
            </b-form-select>
          </b-form-group>
          <div v-if="unir.casaIdx !== null && unir.unidades[unir.casaIdx]" class="small text-muted mb-3">
            Obra {{ unir.unidades[unir.casaIdx].obraRefSap }} · Quadra {{ unir.unidades[unir.casaIdx].quadra }} ·
            Fase {{ unir.unidades[unir.casaIdx].fase }} · {{ unir.unidades[unir.casaIdx].tipoImovel }}
            <span v-if="unir.unidades[unir.casaIdx].jaVinculada"> · (casa já unida)</span>
          </div>
          <div class="text-right">
            <b-button variant="secondary" class="mr-2" @click="$refs.modalUnirSap.hide()">Cancelar</b-button>
            <b-button variant="third" :disabled="unir.casaIdx === null" @click="confirmarUnir">Unir</b-button>
          </div>
        </b-modal>
</div>
</template>

<script>
import sorting from '@/views/private/realestate/ocurrence/components/sorting/sorting.js'
export default sorting
</script>

<style scoped>

#add-new-ocurrence{
    font-size: 28px;
    background-color: #008144;
    outline: transparent;
    color:white;
    width: 64px;
    right: 35px;
    bottom: 60px;
    height: 64px;
    cursor: pointer;
    position: absolute;
    border-radius: 50%;
    border:transparent
}
.button-rep{
    height: 35px;
    width: 150px;
    border-radius: 10px;
    background: red;
    display: flex;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    border: none;
    font-weight: bold;
    font-size: 14px;
    color: white;
}
.button-app{
    height: 35px;
    width: 150px;
    border-radius: 10px;
    border: none;
    background: #008144;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    color: white;
}
.button-undo{
    height: 35px;
    width: 150px;
    border-radius: 10px;
    border: none;
    background: #ffb319;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    color: white;
}
.button-unir{
    height: 35px;
    width: 150px;
    border-radius: 10px;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    color: white;
}
.button-unir-pendente{
    background: #a1a1a1;
}
.button-unir-feito{
    background: #008144;
}
#info-flat-button{
    position: absolute;
    bottom: 150px;
    right: 10px;
    font-family: 'Segoe UI'
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/ocurrence/components/sorting/sorting.vue